import React from "react";
import { Link } from "react-router-dom";

export const SportsSection = ({ payload }) => {
  return (
    <section>
      {payload?.map((item, index) => (
        <div className="feature-section sport-section" key={index}>
          <div className="sport-item">
            <img src={item.uploadedLogo.filePath} />
          </div>
          <div className="sport-item d-block">
            <div className="sport-item-title">{item.title}</div>
            <p className="text-left">{item.details}</p>
            <Link className="white" id="reqdemo" to="/signup">
              <button
                type="button"
                className="request-btn fs-28 bold hero-section-button integration-content-button text-light"
              >
                Request Demo
              </button>
            </Link>
          </div>
        </div>
      ))}
    </section>
  );
};
